import React from "react";

const MySkillsCard = ({ skill }) => {
  const { image, title, value } = skill;
  return (
    <div className="card w-64 md:w-36 shadow-slate-500 shadow-md my-4 p-4">
      <figure>
        <img src={image} alt="react" />
      </figure>
      <div className="card-body">
        <h2 className="card-title mx-auto">{title}</h2>
      </div>
      <div
        className="radial-progress mx-auto my-4"
        style={{ "--value": value }}
      >
        {value}%
      </div>
    </div>
  );
};

export default MySkillsCard;
